import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.regexp.split";
import _objectSpread from "E:\\xinyongban\\xinyidai-frontend\\node_modules\\@babel\\runtime-corejs2/helpers/esm/objectSpread";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:\\xinyongban\\xinyidai-frontend\\node_modules\\@babel\\runtime-corejs2/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.string.ends-with";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import baseUrl from "@/api/baseUrl";
import { selectLicenseList, updateLicense, editUploadDetail, uploadBankLicense, deleteBankLicense } from "@/api/bankcrecenter.js";
import ZipCardUpload from "@/components/ZipCardUpload.vue";
export default {
  components: {
    ZipCardUpload: ZipCardUpload
  },
  data: function data() {
    return {
      uploadURL: baseUrl + 'api/archive/upload',
      headers: {
        token: sessionStorage.getItem('token')
      },
      showDialog: false,
      bankFromPage: {
        page: 1,
        pageSize: 10
      },
      dataTotal: null,
      created: "",
      tableData: [],
      dialogUpload: false,
      isEditMode: false,
      //编辑模式
      bankTitle: "",
      bankImageUrl: "",
      currentId: null,
      // 当前编辑的ID
      fileArray: [],
      modeUploadForm: {
        enterpriseName: "",
        enterpriseCode: "",
        creaTime: [],
        file: null,
        rawFile: null
      },
      rules: {
        enterpriseName: [{
          required: true,
          message: "请输入企业名称",
          trigger: "blur"
        }],
        enterpriseCode: [{
          required: true,
          message: "请输入信用代码",
          trigger: "blur"
        }],
        creaTime: [{
          type: "array",
          required: true,
          message: "请选择日期",
          trigger: "blur"
        }],
        file: [{
          required: true,
          message: "请上传文档文件",
          trigger: "change"
        }]
      },
      editFileRules: [{
        validator: this.validateFiles,
        trigger: "change"
      }],
      existingFileName: null,
      isFileDeleted: false //标记文件是否删除状态

    };
  },
  mounted: function mounted() {
    this.created = sessionStorage.getItem("userName") || "未知用户";
    this.getBankList();
    console.log(this.organization);
  },
  computed: {
    organization: function organization() {
      return this.$store.getters.organization;
    }
  },
  methods: {
    // 上传成功
    handleAvatarSuccess2: function handleAvatarSuccess2(res, file) {
      this.$message.success(res.data);
      this.getBankList();
    },
    // 上传之前
    beforeAvatarUpload2: function beforeAvatarUpload2(file) {
      var isZip = file.type === 'application/zip' || file.type === 'application/x-rar-compressed' || file.name.endsWith('.zip') || file.name.endsWith('.rar');

      if (!isZip) {
        this.$message.error('只允许上传 ZIP 或 RAR 文件');
        return false; // 阻止文件上传
      }

      return true;
    },
    showUpload: function showUpload() {
      this.showDialog = true;
    },
    beforeUpload: function beforeUpload(file) {
      var isExcel = file.type === 'application/vnd.ms-excel' || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

      if (!isExcel) {
        this.$message.error('只允许上传 Excel 文件');
        return false; // 阻止文件上传
      }

      return true; // 允许文件上传
    },
    // 获取银行列表
    getBankList: function () {
      var _getBankList = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return selectLicenseList(_objectSpread({}, this.bankFromPage, {
                  created: this.created
                }));

              case 2:
                res = _context.sent;
                this.tableData = res.data.data.list;
                this.dataTotal = res.data.data.size;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getBankList() {
        return _getBankList.apply(this, arguments);
      }

      return getBankList;
    }(),
    // 自定义文件验证（编辑模式）
    validateFiles: function validateFiles(rule, value, callback) {
      if (this.isEditMode) {
        // 编辑模式：必须上传新文件
        this.fileList.length > 0 ? callback() : callback(new Error("必须上传新文件替换原文件"));
      } else {
        // 新增模式下必须有文件
        if (this.fileList.length > 0) {
          callback();
        } else {
          callback(new Error("请上传PDF文件"));
        }
      }
    },
    // 编辑获取详情
    editUpload: function () {
      var _editUpload = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(row) {
        var _this = this;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.bankTitle = "编辑授权书";
                this.isEditMode = true; // this.isFileDeleted = false; // 重置删除状态

                this.$nextTick(function () {
                  _this.modeUploadForm = {
                    id: row.id,
                    enterpriseName: row.enterpriseName,
                    enterpriseCode: row.enterpriseCode,
                    creaTime: [row.startTime, row.endTime] // file: null

                  };
                }); // this.fileList = []; // 清空上传文件列表

                this.dialogUpload = true;

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function editUpload(_x) {
        return _editUpload.apply(this, arguments);
      }

      return editUpload;
    }(),
    // 删除已有文件
    removeExistingFile: function removeExistingFile() {
      this.existingFileName = "";
      this.isFileDeleted = true;
      this.$refs.formRef.validateField("file"); // 重新验证文件字段
    },
    handleCloseDialog2: function handleCloseDialog2() {
      this.showDialog = false;
    },
    // 关闭弹窗重置
    handleCloseDialog: function handleCloseDialog() {
      this.$refs.formRef.resetFields();
      this.$refs.uploadRef.clearFiles();
      this.fileArray = [];
      this.existingFileName = null;
      this.modeUploadForm = {
        enterpriseName: "",
        enterpriseCode: "",
        creaTime: ""
      };
    },
    // 文件变化处理
    handleFileChange: function handleFileChange(file, fileList) {
      if (!file) return;
      var extension = (file.name.split(".").pop() || "").toLowerCase();
      var isTypeValid = ["application/pdf", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"].includes(file.type) || ["pdf", "doc", "docx"].includes(extension);

      if (!isTypeValid) {
        this.$message.error("文件格式不支持");
        this.$refs.uploadRef.clearFiles();
        return;
      } // 验证文件大小;


      var isLt10M = file.size / 1024 / 1024 < 10;

      if (!isLt10M) {
        this.$message.error("文件超过10MB限制");
        this.$refs.uploadRef.clearFiles();
        return;
      }

      if (fileList.length > 1) {
        fileList.shift();
      } else {
        this.modeUploadForm.file = null;
        this.modeUploadForm.rawFile = null;
      }

      this.fileList = fileList;
      this.modeUploadForm.file = file.raw;
      this.existingFileName = "";
      this.$refs.formRef.validateField("file");
    },
    // 文件移除处理
    handleRemove: function handleRemove(file, fileList) {
      //   this.modeUploadForm.file = null;
      //   this.modeUploadForm.rawFile = null;
      //   console.log(fileList, "fileList");
      this.fileList = fileList;
      this.modeUploadForm.file = null;
      this.$refs.formRef.validateField("file");
    },
    // 文件超出限制
    handleExceed: function handleExceed() {
      this.$message.warning("只能上传一个文件，请先移除当前文件");
    },
    // 确定提交上传接口方法
    submitUpload: function () {
      var _submitUpload = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3() {
        var valid, formData, res, _res;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return this.$refs.formRef.validate();

              case 3:
                valid = _context3.sent;

                if (valid) {
                  _context3.next = 6;
                  break;
                }

                return _context3.abrupt("return");

              case 6:
                // 编辑模式下必须上传新文件
                formData = new FormData();
                formData.append("enterpriseName", this.modeUploadForm.enterpriseName);
                formData.append("enterpriseCode", this.modeUploadForm.enterpriseCode);
                formData.append("authorizedStartTime", this.modeUploadForm.creaTime[0]);
                formData.append("authorizedEndTime", this.modeUploadForm.creaTime[1]); // formData.append("created", this.created);
                // formData.append("organization", this.organization);
                // 只有有新文件时才上传;
                // if (this.modeUploadForm.rawFile) {
                //   //   formData.append("file", this.form.pdfFile);
                //   formData.append("file", this.modeUploadForm.rawFile);
                // }

                if (!this.isEditMode) {
                  _context3.next = 19;
                  break;
                }

                formData.append("id", this.modeUploadForm.id); // formData.append("originalFileName", this.existingFileName.name);
                // if (this.fileList.length > 0) {
                //   // 有新上传的文件
                //   formData.append("file", this.modeUploadForm.file);
                //   if (this.existingFileName) {
                //     formData.append("removeExisting", "true");
                //   }
                // } else if (this.isFileDeleted && this.existingFileName) {
                //   // 删除了原文件且没有上传新文件
                //   formData.append("removeExisting", "true");
                // }
                //   编辑接口

                _context3.next = 15;
                return updateLicense(formData, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                });

              case 15:
                res = _context3.sent;

                if (res.data.code == 200) {
                  this.$message.success("\u7F16\u8F91".concat(res.data.msg));
                  this.getBankList();
                  this.dialogUpload = false;
                } else {
                  this.$message.error("\u7F16\u8F91".concat(res.data.msg));
                }

                _context3.next = 25;
                break;

              case 19:
                if (!(this.fileList.length > 0)) {
                  _context3.next = 25;
                  break;
                }

                formData.append("file", this.modeUploadForm.file); // 调用新增接口

                _context3.next = 23;
                return uploadBankLicense(formData, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                });

              case 23:
                _res = _context3.sent;

                if (_res.data.code == 200) {
                  this.$message.success("\u65B0\u589E".concat(_res.data.msg));
                  this.getBankList();
                  this.dialogUpload = false;
                } else {
                  this.$message.error("\u65B0\u589E".concat(_res.data.msg));
                }

              case 25:
                _context3.next = 30;
                break;

              case 27:
                _context3.prev = 27;
                _context3.t0 = _context3["catch"](0);
                console.error("提交失败:", _context3.t0); // this.$message.error(error.res?.data?.message || "文档提交失败");

              case 30:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 27]]);
      }));

      function submitUpload() {
        return _submitUpload.apply(this, arguments);
      }

      return submitUpload;
    }(),
    // 删除
    deletUpload: function () {
      var _deletUpload = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee4(row) {
        var res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return deleteBankLicense({
                  id: row.id
                });

              case 2:
                res = _context4.sent;

                if (res.data.code == 200) {
                  this.$message.success("\u5220\u9664".concat(res.data.msg));
                  this.getBankList();
                } else {
                  this.$message.error("\u5220\u9664".concat(res.data.msg));
                  this.getBankList();
                }

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function deletUpload(_x2) {
        return _deletUpload.apply(this, arguments);
      }

      return deletUpload;
    }(),
    // 分页
    handleSizeChange: function handleSizeChange(val) {
      this.bankFromPage.pageSize = val;
      this.getBankList(this.bankFromPage);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.bankFromPage.page = val;
      this.getBankList(this.bankFromPage);
    }
  }
};